import type { EnsureNodesInViewEvent } from 'components/Graph/model/GraphCommandEvents';
import type { GraphCommandFactory } from '../model/GraphCommandContext';

export type EnsureNodesInViewCommand = EnsureNodesInViewEvent;

export const ensureNodesInView: GraphCommandFactory<EnsureNodesInViewCommand> =
  (cmdContext) => (command) => {
    cmdContext.eventEmitter.emit('ensureNodesInView', command);
  };
